import PagesTemplate from "./PagesTemplate";
export default PagesTemplate;